import React from 'react'

import { MegaMenuTab, MegaMenuTabProps } from './MegaMenuTab'
import { MegaMenuTabPanel, MegaMenuTabPanelProps } from './MegaMenuTabPanel'
import { MegaMenuTabs, MegaMenuTabsProps } from './MegaMenuTabs'
import { NavDropdownMegaMenuWrapper, NavDropdownMegaMenuWrapperProps } from './NavDropdown'
import { NavDropdownMegaMenuItem, NavDropdownMegaMenuItemProps } from './NavDropdownItem'

export type NavDropdownMegaMenuProps =
  | ({
    wrapper: true;
    item?: false;
    tabs?: false;
    tab?: false;
    tabpanel?: false;
  } & NavDropdownMegaMenuWrapperProps)
  | ({
    wrapper?: false;
    item: true;
    tabs?: false;
    tab?: false;
    tabpanel?: false;
  } & NavDropdownMegaMenuItemProps)
  | ({
    wrapper?: false;
    item?: false;
    tabs: true;
    tab?: false;
    tabpanel?: false;
  } & MegaMenuTabsProps)
  | ({
    wrapper?: false;
    item?: false;
    tabs?: false;
    tab: true;
    tabpanel?: false;
  } & MegaMenuTabProps)
  | ({
    wrapper?: false;
    item?: false;
    tabs?: false;
    tab?: false;
    tabpanel: true;
  } & MegaMenuTabPanelProps)

export const NavDropdownMegaMenu: React.FC<NavDropdownMegaMenuProps> = ({
  wrapper,
  item,
  tabs,
  tab,
  tabpanel,
  ...props
}) => {
  if (item) {
    return <NavDropdownMegaMenuItem {...(props as NavDropdownMegaMenuItemProps)} />
  }

  if (tabs) {
    return <MegaMenuTabs {...(props as MegaMenuTabsProps)} />
  }

  if (tab) {
    return <MegaMenuTab {...(props as MegaMenuTabProps)} />
  }

  if (tabpanel) {
    return <MegaMenuTabPanel {...(props as MegaMenuTabPanelProps)} />
  }

  return <NavDropdownMegaMenuWrapper {...(props as NavDropdownMegaMenuWrapperProps)} />
}
